import React from 'react';
import DashboardCard from './DashboardCard';

const DashboardSection = ({ title, loading, error, cards }) => (
  <section className={`${title.toLowerCase()}-section`} style={{ marginTop: '40px' }}>
    <h3>{title}</h3>
    {loading && <p>Loading {title.toLowerCase()} data...</p>}
    {error && <p className="error">{error}</p>}
    {!loading && !error && (
      <div className="dashboard-cards">
        {cards.map(({ key, title, count, onClick }) => (
          <DashboardCard key={key} title={title} count={count} onClick={onClick} />
        ))}
      </div>
    )}
  </section>
);

export default DashboardSection;
